import React from 'react';
import type { ViewProps } from 'react-native';
import { StyleSheet, View } from 'react-native';
import { theme, useResponsive } from '@sweetgreen/garnish';

export const CheckoutLayout = (props: ViewProps) => {
  const { children } = props;

  const { match } = useResponsive();
  const style = match([{}, {}, styles.layoutDesktopUp]);

  return <View style={style}>{children}</View>;
};

//
// ─── SUBCOMPONENTS ──────────────────────────────────────────────────────────────
//

export const CheckoutLayoutColumn = ({ children }: ViewProps) => {
  const { match } = useResponsive();
  const style = match([{}, {}, styles.columnDesktopUp]);

  return <View style={style}>{children}</View>;
};

export const CheckoutLayoutBlock = ({ testID, children }: ViewProps) => {
  const { currentBreakpoint, match } = useResponsive();
  const layoutBlockResponsiveStyle = currentBreakpoint.isXS
    ? styles.layoutBlockMobile
    : styles.layoutBlockTabletUp;
  const layoutBlockInnerResponsiveStyle = match([
    {},
    styles.layoutBlockInnerTablet,
    styles.layoutBlockInnerDesktopUp,
  ]);
  const layoutBlockInnerStyle = [
    styles.layoutBlockInner,
    layoutBlockInnerResponsiveStyle,
  ];

  return (
    <View testID={testID} style={layoutBlockResponsiveStyle}>
      <View style={layoutBlockInnerStyle}>{children}</View>
    </View>
  );
};

//
// ─── STYLES ─────────────────────────────────────────────────────────────────────
//

const GUTTER_SIZE = theme.spacing['3'];

const styles = StyleSheet.create({
  layoutDesktopUp: {
    flexDirection: 'row',
    flexWrap: 'wrap',
    marginRight: -GUTTER_SIZE,
    marginLeft: -GUTTER_SIZE,
  },

  columnDesktopUp: {
    flexBasis: '50%',
    paddingHorizontal: GUTTER_SIZE,
  },

  layoutBlockMobile: {
    paddingBottom: theme.spacing['10'],
  },
  layoutBlockTabletUp: {
    paddingBottom: theme.spacing['6'],
  },
  layoutBlockInner: {
    backgroundColor: theme.colors.OATMEAL,
  },
  layoutBlockInnerTablet: {
    padding: theme.spacing['10'],
    borderRadius: theme.radius.large,
  },
  layoutBlockInnerDesktopUp: {
    padding: theme.spacing['10'],
    borderRadius: theme.radius.medium,
  },
});
